import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

function BrandMark() {
  return (
    <a href="#home" className="flex items-center gap-2.5" aria-label="宿野吃瓜 回到顶部">
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-white">
        <i className="ri-chat-heart-fill text-lg" aria-hidden="true"></i>
      </span>
      <span className="font-display text-2xl leading-none tracking-wide text-foreground-950">
        宿野<span className="text-primary-600">吃瓜</span>
      </span>
    </a>
  );
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <BrandMark />

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#hot"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            围观热榜
          </a>
          <a
            href="#about"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-edit-2-line mr-1.5 text-base" aria-hidden="true"></i>
            参与讨论
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-900 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto grid max-w-7xl gap-1 px-4 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-2 flex flex-col gap-2 border-t border-background-200 pt-3">
              <a
                href="#hot"
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-900"
              >
                围观热榜
              </a>
              <a
                href="#about"
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
              >
                参与讨论
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}